import styled from 'styled-components'

const InvisibleButton = styled.button.attrs({ type: 'button' })`
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  margin: 0;

  &:focus {
    outline: 0;
  }
`

export default InvisibleButton
